//WE.Flow.Html.Entities.HomeConfig

export class HomeConfig {
    sortOrder: { [key: string]: number } = null;
    blacklist: string[] = null;
    whitelist: string[] = null;
}
